import type { EventHint } from '@sentry/vue'
import type { AxiosError } from 'axios'
import type { App } from 'vue'
import * as Sentry from '@sentry/vue'
import router from '@/router'

export default {
  install(app: App) {
    if (!import.meta.env.VITE_APP_SENTRY_DSN) {
      return
    }

    const tracesSampleRate = Number(import.meta.env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE)

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: tracesSampleRate >= 0 && tracesSampleRate <= 1 ? tracesSampleRate : 0.1,
      attachStacktrace: true,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      ignoreErrors: [
        'Load failed',
        'Unable to preload',
        'Object captured as promise rejection with keys',
        'Invalid call to runtime.sendMessage(). Tab not found.',
        'Object Not Found Matching Id:1, MethodName:update, ParamCount:4',
        'uncaught exception: undefined', // Firefox browser extensions
      ],
      beforeSend(event, hint: EventHint) {
        const originalException = hint?.originalException as AxiosError | undefined
        return originalException?.response?.status === 401 ||
          originalException?.response?.status === 0 ||
          originalException?.code === 'ERR_NETWORK'
          ? null
          : event
      },
    })
  },
}
